import { WebLink } from 'ui/theme';
import { EmptyStateSubtitle } from '../../AudienceSelection.styled';

export const NoListEmptyStateSubtitle = () => (
  <EmptyStateSubtitle>
    <WebLink href="/lists/import" target="_blank" data-test="import-lists-link">
      Import a list
    </WebLink>{' '}
    to get started.
  </EmptyStateSubtitle>
);
